/**
 * @file Consumer custom print checkout view.
 */

import React from 'react';

import CustomPrintCheckoutContainer from '../../containers/custom-prints/CustomPrintCheckoutContainer';

const CustomPrintCheckoutView = () => (
  <div className="wrapper-main content-wrap-gray">
    <div className="custom-prints-view-wrap">
      <CustomPrintCheckoutContainer />
    </div>
  </div>
);

export default CustomPrintCheckoutView;
